module.exports = __webpack_public_path__ + "static/canoloth-a97c0ad3ae463c1479cf8eaa097c21b2.png";